import { Component, OnInit, Input, ViewChild, ElementRef } from '@angular/core';
import { Resources, PopupModelReturn, Appointment, PopupButton ,PopupModel , PopupSetupModel, ServiceProvider, Patient, SP_Type, SPType_ServiceProvider, Lookups, ServiceAreas, Staff } from '../../../AllTableClasses';
import { PopupNotificationService } from '../../../Services/popup-notification.service';
import { SchedulerService } from '../../../Services/scheduler.service';
import { MembersService } from '../../../Services/members.service';
import { ServiceProviderService } from '../../../Services/service-provider.service';
import { NotificationPopupComponent } from '../../Components/notification-popup/notification-popup.component';
import { Router } from '@angular/router';
import { LookupsService } from '../../../Services/lookups.service';
import UserSession from '../../../Config/user-session';
import { Subject, takeUntil } from 'rxjs';
import { StaffService } from '../../../Services/staff.service';
import { NgForm } from '@angular/forms';

@Component({
  selector: 'app-appointment-setup-popup',
  templateUrl: './appointment-setup-popup.component.html',
  styleUrls: ['./appointment-setup-popup.component.scss']
})
export class AppointmentSetupPopupComponent implements OnInit {

  private destroy$ = new Subject<void>();

  popup: PopupSetupModel | null = null;
  popupReturn: PopupModelReturn = new PopupModelReturn();

  public submitted = false;
  IDNumber: string = '';
  Cellphone: string = '';
  Surname: string = '';
  appointmentTime: string = '';

  events: any[] = [];

  selectedAudiologist: Staff = new Staff();
  selectedStaffMember: Staff = new Staff();
  public PopupAction: string = 'Setup';

  serviceAreas: Array<ServiceAreas> = new Array<ServiceAreas>();

  appointment: Appointment = new Appointment();
  patients: Array<Patient> = new Array<Patient>();

  public selectedPatient: Patient = new Patient();
  selectedStartDate!: string;

  public contactMethods = [{ Type: 'SMS' }];

  public staffList: Array<Staff> = new Array<Staff>();
  public doctors: Array<Staff> = new Array<Staff>();

  public SP_Types: Array<SP_Type> = new Array<SP_Type>();
  public AllServices: Array<ServiceProvider> = new Array<ServiceProvider>();
  public filteredServices: Array<ServiceProvider> = new Array<ServiceProvider>();
  public SP_ServiceProviders: Array<SPType_ServiceProvider> = new Array<SPType_ServiceProvider>();

  public selectedDuration!: string;
  public showError: boolean = false;
  public erroMessage!: string;
  public titles: Array<Lookups> = new Array<Lookups>();
  public times: Array<Lookups> = new Array<Lookups>();
  public genders: Array<Lookups> = new Array<Lookups>();
  public durations: Array<Lookups> = new Array<Lookups>();
  public durationOveride?: string;
  public contactSelection!: string;
  public staffMemberError: boolean = false;

  @Input() Data!: Appointment;

  constructor(
    private popupNotificationService: PopupNotificationService,
    private schedulerService: SchedulerService,
    private membersService: MembersService,
    private serviceProviderService: ServiceProviderService,
    private lookupService: LookupsService,
    private staffService: StaffService,
    private router: Router
  ) { }

  ngOnInit(): void {
    this.PopupAction = 'Setup';
    this.popupNotificationService.appointmentNotification$.pipe(takeUntil(this.destroy$)).subscribe((popup: PopupSetupModel | null) => {
      this.popup = popup;
      this.clear();
      this.selectedPatient = new Patient();
      this.durationOveride = undefined;
      if (this.popup) {
        if (popup?.Data != null || popup?.Data != undefined) {
          this.appointment = popup.Data;
          this.audiologistGetByBranchID();
          this.StaffGet();
          this.ServiceAreasGet();
          this.eventsGet();
          this.appointmentTime = this.appointment.StartTime;
          this.selectedStartDate = this.appointment.StartDate;
          this.appointment.StaffMemberID = UserSession.UserID;
        }
        this.TimesGet();
        this.TitleGet();
        this.GenderGet();
        this.DurationsGet();
        this.SPTypeGet();
        this.ServiceProviderGet();
        this.SPTypeServiceProviderGet();
        this.appointment.SendConfirmation = 'SMS';
      }
    });

  }

  StaffUpdate() {
    const selectedStaff = this.staffList.find(staff => staff.ID === this.appointment.StaffMemberID);
    if (selectedStaff) {
      this.selectedStaffMember = selectedStaff;
    }
  }

  AudiologistUpdate() {
    const selectedAudiologist = this.doctors.find(staff => staff.ID === this.appointment.AudiologistID);
    if (selectedAudiologist) {
      this.selectedAudiologist = selectedAudiologist;
    }
  }

  selectDuration() {
    if (this.durationOveride != undefined && this.durationOveride != "") {
      this.appointment.Duration = parseInt(this.durationOveride);
    }
  }

  public DurationsGet() {
    this.lookupService.DurationsGet((data) => {
      if (data.Success) {
        this.durations = data.Data;
      }
      else {

      }
    }, (error) => { });
  }

  public GenderGet() {
    this.lookupService.GenderGet((data) => {
      if (data.Success) {
        this.genders = data.Data;
      }
      else {
        console.log("Error: ", data.UserErrorMessage);
      }
    }, (error) => { });
  }

  public TitleGet() {
    this.lookupService.TitleGet((data) => {
      if (data.Success) {
        this.titles = data.Data;
      }
      else {
        console.log("Error: ", data.UserErrorMessage);
      }
    }, (error) => { });
  }
  public TimesGet() {
    this.lookupService.TimesGet((data) => {
      if (data.Success) {
        this.times = data.Data;
      }
      else {

      }
    }, (error) => { })
  };

  audiologistGetByBranchID() {
    this.staffService.StaffGetByBranchID(this.appointment.BranchID,(data: any) => {
      if (data.Success) {
        this.doctors = data.Data;
        this.AudiologistUpdate();

      } else {
        console.error('Error fetching doctors:', data.Message);
      }
    }, (error: any) => { });
  }

  public StaffGet() {
    this.staffService.StaffGetByBranchID(this.appointment.BranchID, (data) => {
      if (data.Success) {
        this.staffList = data.Data;
        this.StaffUpdate();
      }
      else {
        console.log("Error: ", data.UserErrorMessage);
      }
    }, (error) => { });
  }

  public ServiceAreasGet() {
    this.schedulerService.ServiceAreasGetByBranchID(this.appointment.BranchID, (data: any) => {
      if (data.Success) {
        this.serviceAreas = JSON.parse(data.Data);

      } else {
        console.error('Error fetching serviceAreas:', data.Message);
      }
    }, (error: any) => { });
  }

  public patientsGetByIDNumber() {
    if (this.IDNumber == '' || this.IDNumber == undefined) {
      return
    }
    this.schedulerService.PatientGetByIDNumber(this.IDNumber,(data: any) => {
      if (data.Success) {
        this.patients = JSON.parse(data.Data);
        this.PopupAction = 'View';
      } else {
        console.error('Error fetching events:', data.Message);
      }
    }, (error: any) => {});
  }

  public patientsGetBySurname() {
    if (this.Surname == '' || this.Surname == undefined) {
      return
    }
    this.schedulerService.MemberGetBySurname(this.Surname, (data: any) => {
      if (data.Success) {
        this.patients = JSON.parse(data.Data);
        this.PopupAction = 'View';
      } else {
        console.error('Error fetching events:', data.Message);
      }
    }, (error: any) => { });
  }

  public patientsGetByCellphone() {
    if (this.Cellphone == '' || this.Cellphone == undefined) {
      return
    }
    this.schedulerService.PatientGetByCellphone(this.Cellphone, (data: any) => {
      if (data.Success) {
        this.patients = JSON.parse(data.Data);
        this.PopupAction = 'View';
      } else {
        console.log("Error: ", data.UserErrorMessage);
      }
    }, (error: any) => {});
  }

  public onSubmit(form: NgForm): void {
    this.submitted = true;
    this.staffMemberError = false;
    if (!this.appointment.StaffMemberID) {
      this.staffMemberError = true;
    }
    if (form.valid && this.staffMemberError == false) {
      this.ButtonClick();
    } else {
      console.log('Form is not valid');
    }
  }


  ButtonClick() {
    debugger;
    if (this.selectedStartDate == undefined || this.selectedStartDate == '') {
      this.showError = true;
      this.erroMessage = 'Please select a date';
      return;
    }

    if (this.appointmentTime == undefined || this.appointmentTime == '') {
      this.showError = true;
      this.erroMessage = 'Please select a time';
      return;
    }

    if (this.appointment.ServiceProviderID == undefined || this.appointment.ServiceProviderID == 0) {
      this.showError = true;
      this.erroMessage = 'Please select a Service';
      return;
    }

    //if (this.appointment.LocationID == undefined || this.appointment.ServiceProviderID == 0) {
    //  this.showError = true;
    //  this.erroMessage = 'Please select a location/ testing facility';
    //  return;
    //}

    this.submitted = true;
    this.appointment.SPType
    this.appointment.PatientID = this.selectedPatient.ID;

    this.appointment.EndTime = this.addMinutesToTime(this.appointmentTime, this.appointment.Duration);
    this.appointment.EndDate = this.selectedStartDate + ' ' + this.appointment.EndTime;
    this.appointment.StartDate = this.selectedStartDate + ' ' + this.appointmentTime;

    const patientExists = this.patients.some(patient => patient.IDNumber === this.selectedPatient.IDNumber);

    if (patientExists) {
      this.selectedPatient.Status = 'OLD PATIENT';
    } else {
      this.selectedPatient.Status = 'NEW PATIENT';
    }

    const conflictResult = this.hasConflict(this.appointment);

    if (conflictResult.hasConflict) {

      const conflictMsg = `Conflict with "${conflictResult.conflictingEvent?.ServiceName}" scheduled from ${this.formatDate(
        conflictResult.conflictingEvent?.startDate
      )} to ${this.formatDate(conflictResult.conflictingEvent?.endDate)}.`;
      this.showError = true;
      this.erroMessage = conflictMsg;

      return;
    }

    this.selectedPatient.ParentMemberGuid = this.staffList.find(staff => staff.ID == this.appointment.StaffMemberID)!.Guid;
    if (this.selectedPatient.Status != 'OLD PATIENT') {
      this.selectedPatient.Status = 'NEW PATIENT';
    }
    this.membersService.MemberSetByGuid(this.selectedPatient, (data: any) => {
      if (data.Success) {
        this.appointment.PatientID = data.Data;
        if (this.popup?.Button) {
          this.popupReturn.Result = this.popup.Button.Result;
          this.popupReturn.Data = this.appointment;
          this.cancel();
          this.popupNotificationService.ResolveAppointmentPopup(this.popupReturn);
        }
      } else {
        this.erroMessage = data.UserErrorMessage;
        this.showError = true;
        //console.log("Error: ", data.UserErrorMessage);
      }
    }, (error: any) => { });
  }

  AltButtonClick() {
    if (this.popup?.AltButton) {
      this.popupReturn.Result = this.popup.AltButton.Result;
      this.popupNotificationService.ResolveAppointmentPopup(this.popupReturn);
    }
    this.cancel();
    this.PopupAction = 'Setup'
  }

  PopupEvent(event: string) {
    if (event === 'close') {
      this.popupReturn.Result = 'close';
      this.popupNotificationService.ResolveAppointmentPopup(this.popupReturn);
      this.cancel();
    }
    this.PopupAction = 'Setup'
  }

  navigateToSetup() {
    this.PopupAction = 'Setup';
    this.clear();
  }

  navigateToView() {
    this.PopupAction = 'View';
  }

  navigateToEdit(patient: Patient) {
    this.PopupAction = 'EDIT';
    this.selectedPatient = patient;
  }

  navigateToCapture(patient: Patient) {
    this.PopupAction = 'SELECT';
    this.selectedPatient = patient;
    this.appointment.PatientID = this.selectedPatient.ID;
  }

  navigateToCaptureNew() {
    this.PopupAction = 'NEW';
    this.selectedPatient = new Patient();
  }

  public SPTypeGet() {
    this.serviceProviderService.SPTypeGet((data) => {
      if (data.Success) {
        this.SP_Types = data.Data;

      }
    }, (error) => { });

  }

  public SPTypeServiceProviderGet() {
    this.serviceProviderService.SPTypeServiceProviderGet((data) => {
      if (data.Success) {
        this.SP_ServiceProviders = data.Data;

      }
      else {
        console.log("Error: ", data.UserErrorMessage);
      }
    }, (error) => { });
  }

  public ServiceProviderGet() {
    this.serviceProviderService.ServiceProviderGet((data) => {
      if (data.Success) {
        this.AllServices = data.Data;
      }
      else {

      }
    }, (error) => { });
  }

  public onServiceTypeChange() {
    if (this.appointment.SPType) {
      let selectedSP = this.SP_Types.filter(sp => sp.SPType == this.appointment.SPType)[0];

      this.filteredServices = this.AllServices.filter(service => service.SPTypeGuid == selectedSP.Guid);
    } else {
      this.filteredServices = [];  // Clear services if no service type is selected
    }
  }

  public onServiceChange() {
    if (this.appointment.ServiceProviderID) {
      this.appointment.Duration = this.filteredServices.filter(sp => sp.ID == this.appointment.ServiceProviderID)[0].Duration;
    }
    else {
      this.appointment.Duration = 0;
    }
  }

  public save() {
    this.appointment.SPType
    this.appointment.PatientID = this.selectedPatient.ID;
    this.appointment.EndTime = this.addMinutesToTime(this.appointmentTime, this.appointment.Duration);
    this.appointment.EndDate = this.appointment.StartDate + ' ' + this.appointment.EndTime;
    this.appointment.StartDate = this.appointment.StartDate + ' ' + this.appointmentTime;
    this.selectedPatient.ContactMethod = this.appointment.SendConfirmation;
    const patientExists = this.patients.some(patient => patient.IDNumber === this.selectedPatient.IDNumber);

    if (patientExists) {
      this.selectedPatient.Status = 'OLD PATIENT';
    } else {
      this.selectedPatient.Status = 'NEW PATIENT';
    }
    
    const conflictResult = this.hasConflict(this.appointment);

    if (conflictResult.hasConflict) {

      const conflictMsg = `Conflict with "${conflictResult.conflictingEvent?.ServiceName}" scheduled from ${this.formatDate(
        conflictResult.conflictingEvent?.startDate
      )} to ${this.formatDate(conflictResult.conflictingEvent?.endDate)}.`;

      this.showError = true;
      this.erroMessage = conflictMsg;
      return;
    }

    this.membersService.MemberSetByGuid(this.selectedPatient, (data: any) => {
      if (data.Success) {

      } else {
        console.log("Error: ", data.UserErrorMessage);
      }
    }, (error: any) => { });

    this.schedulerService.AppointmentSet(this.appointment, this.appointment.BranchID, (data: any) => {
      if (data.Success) {
          
      } else {
        console.log("Error: ", data.UserErrorMessage);
      }
    }, (error: any) => { });
  }

  public saveMember() {
    this.membersService.MemberSetByGuid(this.selectedPatient, (data: any) => {
      if (data.Success) {

      } else {
        console.log("Error: ", data.UserErrorMessage);
      }
    }, (error: any) => { });
  }

  public clear() {
    this.submitted = false;
    this.appointment.SendConfirmation = 'SMS';
    this.appointment.LocationID = undefined;
    this.appointment.AppointmentNotes = '';

    this.durationOveride = undefined;
    this.filteredServices = [];
  }

  public cancel() {
    this.appointment.SendConfirmation = 'SMS';
    this.appointment = new Appointment();
    this.IDNumber = '';
    this.Cellphone = '';
    this.Surname = '';
    this.erroMessage = '';
    this.durationOveride = undefined;
    this.filteredServices = [];
    this.PopupAction = 'Setup';
  }

  ngOnDestroy(): void {
    // Emit and complete the destroy$ Subject to clean up subscriptions
    this.destroy$.next();
    this.destroy$.complete();
  }

  public eventsGet() {
    this.schedulerService.EventsGet(this.appointment.BranchID,(data: any) => {
      if (data.Success) {
        this.events = JSON.parse(data.Data);
      } else {
        console.error('Error fetching events:', data.Message);
      }
    }, (error: any) => { });
  }

  public hasConflict(appointment: Appointment): { hasConflict: boolean; conflictingEvent?: any } {

    const conflict = this.events.find(event => {
      if (event.resourceId === appointment.AudiologistID) {
        const existingStart = new Date(event.startDate).getTime();
        const existingEnd = new Date(event.endDate).getTime();
        const newStart = new Date(appointment.StartDate).getTime();
        const newEnd = new Date(appointment.EndDate).getTime();

        return newStart < existingEnd && newEnd > existingStart;
      }
      return false;
    });

    if (conflict) {
      return { hasConflict: true, conflictingEvent: conflict };
    }
    return { hasConflict: false };
  }

  formatDate(dateString: string): string {
    const date = new Date(dateString);
    return date.toLocaleString(); // Format date as 'MM/DD/YYYY, HH:MM:SS'
  }

  public addMinutesToTime(timeString : string, minutesToAdd: number) {
    // Convert "08:00" to a Date object
    const [hours, minutes] = timeString.split(':');
    const date = new Date();
    date.setHours(parseInt(hours));
    date.setMinutes(parseInt(minutes));

    // Add the desired minutes
    date.setMinutes(date.getMinutes() + minutesToAdd);

    // Format the updated time back to "HH:mm"
    const updatedHours = date.getHours().toString().padStart(2, '0');
    const updatedMinutes = date.getMinutes().toString().padStart(2, '0');

    return `${updatedHours}:${updatedMinutes}`;
  }

  public showNotifcationPopup(success: boolean, message?: string) {
    let notificationPopup: PopupModel = new PopupModel();

    if (success == true) {
    }
    else {
      notificationPopup.Message = message;
      notificationPopup.MessageType = 'error';
      this.popupNotificationService.ShowPopup(notificationPopup).then((res: PopupModelReturn) => {

      });
    }

  }
}
